module.exports = __webpack_public_path__ + "static/media/carousel_3.54789144.jpg";